import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Backdrop,
  Snackbar,
  Alert,
  InputAdornment,
  useMediaQuery,
} from '@mui/material';
import {useEffect, useState} from 'react';
import AtplPrimaryBt from '../../components/ATPlab/AtplPrimaryBtn/AtplPrimaryBt';
import AtplFooter from '../../components/ATPlab/atpFooter/AtplFooter';
import AtplLinearBar from '../../components/ATPlab/AtplLinearBar';
import {useNavigate} from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {useTheme} from '@emotion/react';
import {PrivacyContent} from '../TermsAndPrivacy/privacyContent';
import ConfirmationDialog from '../../components/dialogbox/confirmationDialog';
import {TermsOfServiceContent} from '../TermsAndPrivacy/termsOfServiceContent';
import CloseIcon from '@mui/icons-material/Close';
import {useClientApi} from '../../api/client';
import {convertFeetAndInchesToCentimeters, convertPoundsToKilograms} from '../../utils/conversions';
import {CLIENT_TYPES} from '../../api/clientconfig';
import {AnimationLoadingScreenWithProgressBar} from '../../components/loading/loadingScreen';

import dayjs from 'dayjs';
import {SimpleLoader} from '../../components/loading/simpleLoader';
import {allergenData} from '../../data/allergenData';
import {drugData} from '../../data/drugsData';
import {medicalConditionsData} from '../../data/medicalConditionsData';
import AtplPrimaryBtnNew from '../../components/ATPlab/AtplPrimaryBtn/AtplPrimaryBtnNew';
import {ATPLBackButton} from '../../components/ATPlab/AtplBackBtn';

const CommonErrorMessage = ({text, sx}) => {
  return (
    <Typography
      variant="caption"
      color="error"
      display="flex"
      textAlign="start"
      width="100%"
      gutterBottom
      sx={{
        fontSize: {
          xs: '12px',
          sm: '12px',
          md: '16px',
          lg: '16px',
        },
        padding: '4px 0px 0px 6px', // Padding for the text
        gutterBottom: true, // This adds bottom spacing
        ...sx,
      }}
    >
      {text}
    </Typography>
  );
};
export const AtplHealthProfileQue = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isServerError, setIsServerError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const clientApi = useClientApi(CLIENT_TYPES.ATP);
  const [currentStep, setCurrentStep] = useState(2);
  const [openModalPrivacy, setOpenModalPrivacy] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [formError, setFormError] = useState({
    name: '',
    email: '', // Error message for name field
    allergies: '',
    supplements: '',
    medicalCondition: '',
    wellnessGoal: '',
  });

  const [openModalTerms, setOpenModalTerms] = useState(false);
  const [isTermsChecked, setIsTermChecked] = useState({
    agreeTerm1: false,
    agreeTerm2: false,
    termsNotAgreedError: false,
  });
  const [confirmDialog, setConfirmDialog] = useState({
    title: '',
    subTitle: '',
    isOpen: false,
  });
  const [inputValue, setInputValue] = useState(''); // This will store the current input value for CustomFildForDetailQuestion

  // Default user data
  const defaultUserData = {
    gender: '', // Default: Female
    dateOfBirth: dayjs('1990-01-01'), // Default date
    smoker: false,
    weight: '',
    height: '',
    ethnicity: '',
    isFrontendHeightImperialUnits: false,
    isFrontendWeightImperialUnits: false,
    diabetes: '',
    isPregnant: false,
    menopausalStatus: '',
    isSmoke: false,
    isHighBP: false,
    hasHadHeartAttack: false,
    hasHadStroke: false,
    bpMeds: false,
    isHealthSymptoms: '',
    wellnessGoal: [],
    medicalCondition: [],
    allergies: [],
    isTakingSupplements: false,
    supplements: [],
    email: '',
    name: '',
    isPregnantId: '',
  };
  // Retrieve user data from localStorage or use default
  const [userData, setUserData] = useState(() => {
    const storedUserData = localStorage.getItem('userData');
    if (storedUserData) {
      return JSON.parse(storedUserData);
    }
    return defaultUserData;
  });

  // Handler for "Next" button to store data in localStorage
  const handleNext = () => {
    // Check if userData exists in localStorage
    const storedUserData = localStorage.getItem('userData');
    if (storedUserData) {
      // If userData exists, merge with new data
      const currentUserData = JSON.parse(storedUserData);
      const updatedUserData = {...currentUserData, ...userData};
      // Store merged data back to localStorage
      localStorage.setItem('userData', JSON.stringify(updatedUserData));
    } else {
      // If userData doesn't exist, store the current userData
      localStorage.setItem('userData', JSON.stringify(userData));
    }
  };

  // // Effect to check localStorage when the component mounts
  useEffect(() => {
    // Check if 'flowComingFromAtpResultPage' exists in localStorage
    const flowComingFromAtpResultPage = localStorage.getItem('flowComingFromAtpResultPage');

    // If it exists and is equal to 'true', set currentStep to 17, otherwise set it to 2
    if (flowComingFromAtpResultPage === 'true') {
      setCurrentStep(15);
    } else {
      // if gender is male dont show preganant page
      if (userData && userData?.gender === 'male') {
        setCurrentStep(3);
        setUserData(prev => ({
          ...prev,
          isPregnant: false,
        }));
      } else {
        setCurrentStep(2);
      }
    }
  }, []);

  //Handle agree terms & condition logic
  const handleCheckboxChange = event => {
    const {name, checked} = event.target;

    // Update the specific checkbox
    setIsTermChecked(prevState => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const handleNextStep = field => {
    let isValid = true;

    // Validate email
    if (field === 'email' && !isValidEmail(userData.email)) {
      setFormError(prevState => ({
        ...prevState,
        [field]: 'Please enter a valid email address.',
      }));
      isValid = false;
    }

    // Validate name
    if (field === 'name' && !isValidName(userData.name)) {
      setFormError(prevState => ({
        ...prevState,
        [field]: 'Please enter a valid name. (Only letters and spaces are allowed)',
      }));
      isValid = false;
    }

    // Validate array fields (e.g., medicalCondition, allergies, supplements)
    if (field === 'medicalCondition' || field === 'allergies' || field === 'supplements') {
      if (!userData[field]?.length) {
        setFormError(prevState => ({
          ...prevState,
          [field]: 'Please add details',
        }));
        isValid = false;
      }
    }

    if (field === 'wellnessGoal') {
      if (!userData[field]?.length) {
        setFormError(prevState => ({
          ...prevState,
          wellnessGoal: 'Please select your goal',
        }));
        isValid = false;
      }
    }

    // If all fields are valid, proceed to the next step
    if (isValid) {
      proceedToNextStep();
    }
  };

  const handleEmptySymptoms = async (sessionId, resultsToken) => {
    if (!sessionId || !resultsToken) {
      setIsServerError(true);
      return;
    }
    try {
      setIsLoading(true);
      await clientApi.postSymptoms(sessionId, null, resultsToken);
      localStorage.removeItem('conditions');
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
      setIsServerError(true);
    }
  };

  const sendSymptomDataToBakend = async () => {
    // const sessionId = localStorage.getItem('session-id');
    const sessionId = localStorage.getItem('atpl-session-id');
    const resultsToken = localStorage.getItem('results_token') || '';
    const isExperiencingHealthSymptomDecAtpl = localStorage.getItem('symptomDescAtpl');
    const isExpirienceSymptom = localStorage.getItem('isExperiencingHealthSymptomAtpl') || false;

    if (isExpirienceSymptom && !isExperiencingHealthSymptomDecAtpl) {
      localStorage.removeItem('symptomDescAtpl');
      localStorage.removeItem('conditions');
      await handleEmptySymptoms(sessionId, resultsToken);
      return;
    }
    if (isExpirienceSymptom && isExperiencingHealthSymptomDecAtpl) {
      if (!sessionId) {
        setIsServerError(true);
        return;
      }
      try {
        setIsLoading(true);
        const response = await clientApi.postSymptoms(sessionId, isExperiencingHealthSymptomDecAtpl, resultsToken);

        if (response.conditions) {
          localStorage.setItem('conditions', JSON.stringify(response.conditions));
        }
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
        console.error(error);
        setIsServerError(true);
      }
    }
  };

  const proceedToNextStep = () => {
    // Clearing all errors before proceeding
    clearAllFormError();

    // Moving to the next step
    setCurrentStep(prev => prev + 1);

    // Reset additional input fields if necessary (e.g., multiple-choice selections)
    clearMultipleAnswerInput();
  };

  const handleSkip = field => {
    clearAllFormError();
    if (field === 'name' || field === 'email') {
      setUserData(prevState => ({
        ...prevState,
        [field]: '', // Set the specific field to an empty string
      }));
    }
    if (field === 'medicalCondition' || field === 'allergies' || field === 'supplements' || field === 'wellnessGoal') {
      setUserData(prevState => ({
        ...prevState,
        [field]: [], // Set the specific field to an empty array
      }));
    }
    setCurrentStep(prev => prev + 1);
  };

  //Handles action to close terms of use modal dialog
  const closeTermsModal = isClose => {
    setOpenModalTerms(isClose);
  };

  //Handles action to close privacy policy modal dialog
  const closePrivacyPolicyModal = isClose => {
    setOpenModalPrivacy(isClose);
  };

  //Handles action to open privacy policy modal dialog
  const handlePrivacyPolicy = () => {
    setOpenModalPrivacy(true);
  };

  //Handles action to open terms of use modal dialog
  const handleTermsOfUse = () => {
    setOpenModalTerms(true);
  };

  const isValidEmail = email => {
    // Simple email regex pattern
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };

  const isValidName = name => {
    // Ensure `name` is a string before applying `trim()`
    const trimmedName = name?.trim();
    const namePattern = /^[A-Za-zÀ-ÿ\s]+$/;

    // Check if trimmedName is a non-empty string and matches the pattern
    return trimmedName && namePattern.test(trimmedName);
  };

  const GetMyResultBtnhandler = async () => {
    if (isTermsChecked.agreeTerm1 && isTermsChecked.agreeTerm2) {
      console.log(userData);
      await handleDataSubmit(); //wait for async call
      await sendSymptomDataToBakend(); // Wait for the async call to complete
      handleNext();
      navigate(`/atpl-results`);
    } else {
      setIsTermChecked(prevState => ({
        ...prevState,
        termsNotAgreedError: true,
      }));
    }
  };

  const handleDataSubmit = async () => {
    // Handle height conversion and rounding
    const finalHeight = Math.round(
      userData.isFrontendHeightImperialUnits
        ? convertFeetAndInchesToCentimeters(Number(userData.height.ft), Number(userData.height.in))
        : Number(userData.height.cm),
    );

    // Handle weight conversion and rounding
    const finalWeight = Math.round(
      userData.isFrontendWeightImperialUnits
        ? convertPoundsToKilograms(Number(userData.weight))
        : Number(userData.weight),
    );

    const sessionId = localStorage.getItem('session-id');

    const extraDemographics = {
      birthDate: userData.dateOfBirth,
      gender: userData.genderId,
      ethinicity: userData.ethnicity,
      height: finalHeight,
      weight: finalWeight,
      isFrontendHeightImperialUnits: userData.isFrontendHeightImperialUnits,
      isFrontendWeightImperialUnits: userData.isFrontendWeightImperialUnits,
      isSmoke: userData.isSmoke,
      isDiabetes: userData.diabetes,
      hasHighBP: userData.isHighBP,
      hasHadStroke: userData.hasHadStroke,
      hasHadAttack: userData.hasHadHeartAttack,
      isOnBpMeds: userData.bpMeds,
      isPregnant: userData.isPregnant,
      hasMedicalCondition: userData.medicalCondition?.length > 0 ? true : false,
      medicalConditionNames: userData.medicalCondition?.length ? userData.medicalCondition : null, // if no medical condition added, send null
      hasAllergies: userData.allergies?.length > 0 ? true : false,
      allergyNames: userData.allergies?.length > 0 ? userData.allergies : null, // if no allergy aded ,send null
      hasSupplements: userData.isTakingSupplements,
      supplements: userData.isTakingSupplements ? userData.supplements : null, // if select not taking supplement send null
      wellnessGoals: userData.wellnessGoal?.length > 0 ? userData.wellnessGoal : null,
      menopausalStatus: userData.menopausalStatus || null, // Send it even if unsure
    };

    let assessmentId = localStorage.getItem('atpl-assessment-id');
    try {
      setIsLoading(true);
      const response = await clientApi.postDemographicsNew(extraDemographics, assessmentId);

      if (response && response.data) {
        setIsLoading(false);
      } else {
        throw new Error('Invalid API response');
      }
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  const clearMultipleAnswerInput = () => {
    setInputValue('');
  };

  //handle wellness goal selection
  const handleOptionToggle = value => {
    //clear form error
    clearAllFormError();
    setUserData(prevState => {
      // Ensure wellnessGoal is always an array (default to empty array if undefined or not an array)
      const wellnessGoal = Array.isArray(prevState?.wellnessGoal) ? prevState.wellnessGoal : [];

      // Toggle the value
      const newGoals = wellnessGoal.includes(value)
        ? wellnessGoal.filter(goal => goal !== value) // Deselect if already selected
        : [...wellnessGoal, value]; // Select if not selected

      return {
        ...prevState,
        wellnessGoal: newGoals,
      };
    });
  };

  useEffect(() => {
    if (!userData.isTakingSupplements) {
      setUserData(prev => ({
        ...prev,
        supplements: [],
      }));
    }
  }, [userData.isTakingSupplements]);

  const handleOptionSelect = (field, value, idForPregnantField) => {
    // If the field is for high blood pressure and the value is false,
    // automatically set blood pressure medication to false
    if (field === 'isHighBP' && !value) {
      setUserData(prev => ({
        ...prev,
        [field]: value,
        bpMeds: false, // Automatically set bp meds to false when high BP is no
      }));

      // Skip the next step (BP meds question)
      setCurrentStep(prev => prev + 2);
      return;
    }

    setUserData(prev => ({
      ...prev,
      [field]: value,
    }));

    if (field === 'isPregnant') {
      setUserData(prev => ({
        ...prev,
        isPregnantId: idForPregnantField,
      }));
    }

    if (field === 'isTakingSupplements' && !value) {
      setCurrentStep(prev => prev + 2);
    } else {
      handleNextStep();
    }
  };

  const handleInputChange = (field, value) => {
    setUserData(prev => ({
      ...prev,
      [field]: value,
    }));
    clearAllFormError(); //clear error as user start typing
  };

  // Handles input change for fields like allergy, medication, and supplement
  const CustomFildForDetailQuestionInputChange = (e, field, relatedsuggestionList) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    let filtered = [];
    // Filter the available options based on the input value (case-insensitive match)
    filtered = relatedsuggestionList.filter(
      option => option.toLowerCase().includes(newValue.toLowerCase()), // Filter options by containing match
    );

    //      filtered = relatedsuggestionList.filter(option =>
    //         option.toLowerCase().startsWith(newValue.toLowerCase())  // Filter options by starting match
    //     );

    // Update the filtered options state
    setFilteredOptions(filtered);

    // Clear form errors as the user starts typing
    clearAllFormError();
  };

  const clearAllFormError = () => {
    setFormError({
      name: '',
      email: '', // Error message for name field
      allergies: '',
      supplements: '',
      medicalCondition: '',
    });
  };

  const updateListInputsValue = (e, field) => {
    setUserData(prevState => {
      // Dynamically update the field (using bracket notation to access field dynamically)
      const updatedField = prevState[field] ? [...prevState[field], inputValue.trim()] : [inputValue.trim()];
      return {
        ...prevState,
        [field]: updatedField, // Dynamically set the field value
      };
    });

    // Reset input value after adding to the array
    setInputValue('');
  };

  // Function to handle dynamic field update on "Enter" key press
  const CustomFieldForDetailQuestionKeyPress = (e, field) => {
    // Check if the "Enter" key is pressed and input is not empty
    if (e.key === 'Enter' && inputValue.trim() !== '') {
      updateListInputsValue(e, field);
      clearAllFormError();
    }
  };

  //this fn will handle add btn click logic for add allergy,medication to list
  const onAddBtnClick = (e, field) => {
    if (inputValue.trim() !== '') {
      updateListInputsValue(e, field);
      clearAllFormError();
    }
  };

  // dynamically Remove item from userdata fields with array option
  const onCloseIconClickInOptionArrayList = (itemToRemove, field) => {
    setUserData(prevState => {
      const updatedField = prevState[field].filter(item => item !== itemToRemove);
      return {
        ...prevState,
        [field]: updatedField,
      };
    });
  };

  const onBackArrowClickHandler = () => {
    // if isTakingSupplements condition present will go back one step else2
    setInputValue('');
    if (currentStep > (userData.gender === 'male' ? 3 : 2)) {
      if (currentStep == 15) {
        if (userData.isTakingSupplements) {
          setCurrentStep(14);
        } else {
          setCurrentStep(13);
        }
      } else if (currentStep == 8) {
        if (userData.isHighBP) {
          setCurrentStep(prev => prev - 1);
        } else {
          setCurrentStep(prev => prev - 2);
        }
      } else {
        setCurrentStep(prev => prev - 1);
      }
    } else {
      localStorage.setItem('flowComingFromAtpResultPage', 'false');
      navigate('/atpl-symptom-checker');
    }
  };

  // Handles selection of a suggested option for a specific field
  const handleSuggestedOptionSelect = (field, option, availableOptions) => {
    console.log('Selected Field:', field, 'Selected Option:', option);

    // Ensure that the field exists and is an array
    const currentFieldData = Array.isArray(userData[field]) ? userData[field] : [];

    // Check if the option is already added to avoid duplicates
    if (!currentFieldData.includes(option)) {
      setUserData(prev => ({
        ...prev,
        [field]: Array.isArray(prev[field]) ? [...prev[field], option] : [option], // Ensure prev[field] is an array
      }));
    }

    // Clear the input field after selection
    setInputValue('');

    // Reset filtered options based on the selected field
    setFilteredOptions(availableOptions); // Reset only the options for the selected field
  };

  const renderStep = () => {
    switch (currentStep) {
      // case 0:
      //     return renderStep1();
      // case 1:
      //     return renderStep2();
      case 2:
        return renderStep3();
      case 3:
        // Show menopause screen only if female and not pregnant
        if (userData.gender === 'female' && userData.isPregnantId === 3) {
          return renderStep4A(); // menopause
        } else {
          return renderStep4(); // skip menopause and go to smoking
        }
      case 4:
        return renderStep4(); // smoking (or next after menopause)
      case 5:
        return renderStep5();
      case 6:
        return renderStep6();
      case 7:
        return renderStep7();
      case 8:
        return renderStep8();
      case 9:
        return renderStep9();
      case 10:
        return renderStep10();
      case 11:
        return renderStep11();
      case 12:
        return renderStep12();
      case 13:
        return renderStep13();
      case 14:
        return renderStep14();
      case 15:
        return renderStep15();
      case 16:
        return renderStep16();
      //            case 16:
      //                return renderStep17();
      //            case 17:
      //                return renderStep18();

      default:
        return null;
    }
  };

  const renderStep3 = () => (
    <StepContainer title="Are you pregnant or breastfeeding?">
      {[
        {label: 'Yes, I am pregnant.', id: 1, value: true},
        {label: 'Yes, I am breastfeeding.', id: 2, value: true},
        {label: 'No', id: 3, value: false},
      ].map((option, index) => (
        <OptionButton
          optionSelectSingleValue={userData.isPregnantId} // Pass the current selected value
          value={option.id} // Pass value to compare with userData
          key={index}
          option={option.label}
          onClick={() => handleOptionSelect('isPregnant', option.value, option.id)}
        />
      ))}
    </StepContainer>
  );

  const renderStep4 = () => (
    <StepContainer
      title="Do you smoke?"
      // sx={{
      //     mt: {
      //         xs: 8,
      //         sm: 10,
      //         md: 12
      //     }
      // }}
    >
      <Stack
        sx={{
          width: '100%',
          alignItems: 'center', // Center the buttons
          justifyContent: 'center',
        }}
      >
        {[
          {label: 'Yes', value: true},
          {label: 'No', value: false},
        ].map((option, index) => (
          <OptionButton
            optionSelectSingleValue={userData.isSmoke} // Pass the current selected value
            value={option.value} // Pass value to compare with userData
            key={index}
            option={option.label}
            onClick={() => handleOptionSelect('isSmoke', option.value)}
          />
        ))}
      </Stack>
    </StepContainer>
  );

  const renderStep4A = () => (
    <StepContainer title="What best describes your current menopausal status?">
      {[
        {
          heading: 'I have not started menopause',
          description: 'pre-menopausal',
        },
        {
          heading: 'I am in perimenopause',
          description: 'transition phase with irregular periods and/or symptoms',
        },
        {
          heading: 'I am in menopause',
          description: '12 consecutive months without a period, not due to other causes',
        },
        {
          heading: 'I am post-menopausal',
          description: 'more than 12 months since my last period',
        },
        {
          heading: 'I am unsure',
          description: '',
        },
      ].map((option, index) => (
        <OptionButton
          key={index}
          optionSelectSingleValue={userData.menopausalStatus}
          value={`${option.heading}${option.description ? ` (${option.description})` : ''}`}
          option={
            <Box sx={{textAlign: 'center'}}>
              <Typography sx={{fontWeight: 'bold'}}>{option.heading}</Typography>
              {option.description && <Typography sx={{fontSize: '0.9em'}}>{option.description}</Typography>}
            </Box>
          }
          onClick={() => {
            setUserData(prev => ({
              ...prev,
              menopausalStatus: `${option.heading}${option.description ? ` (${option.description})` : ''}`,
            }));
            setCurrentStep(4); // move to next step after selection
          }}
        />
      ))}
    </StepContainer>
  );

  const renderStep5 = () => (
    <StepContainer title="Are you diabetic?">
      {[
        {label: 'Type 1', value: 1},
        {label: 'Type 2', value: 2},
        {label: 'No', value: 3},
      ].map((option, index) => (
        <OptionButton
          optionSelectSingleValue={userData.diabetes} // Pass the current selected value
          value={option.value} // Pass value to compare with userData
          key={index}
          option={option.label}
          onClick={() => handleOptionSelect('diabetes', option.value)}
        />
      ))}
    </StepContainer>
  );

  const renderStep6 = () => (
    <StepContainer
      title="What is your ethnicity?"
      sx={{
        // mt: {
        //     xs: "14px",

        // },
        gap: {
          xs: '14px', //gap between title & option
          sm: 2,
          md: 2,
          lg: 2,
        },
      }}
    >
      <Stack
        sx={{
          width: '100%',
          alignItems: 'center',
        }}
      >
        {[
          {label: 'American Indian or Alaska Native', value: 1},
          {label: 'Asian', value: 2},
          {label: 'Black or African American', value: 3},
          {label: 'Hispanic or Latino', value: 4},
          {label: 'Native Hawaiian or Pacific Islander', value: 5},
          {label: 'White', value: 6},
          {label: 'Mixed', value: 7},
          {label: 'Prefer not to say', value: 8},
        ].map((option, index) => (
          <OptionButton
            key={index}
            optionSelectSingleValue={userData.ethnicity} // Pass the current selected value
            value={option.value} // Pass value to compare with userData
            option={option.label}
            onClick={() => handleOptionSelect('ethnicity', option.value)}
            optionBtnSx={{
              // margin: "0px 0px",
              marginBottom: '8px',
              height: {
                xs: '36px',
                sm: '48px',
                md: '48px',
                lg: '50px',
              },
              // boxShadow: "rgba(0, 0, 0, 0.15) 0px 1px",
              // marginBottom: '0px',
              gap: 0,
            }}
          />
        ))}
      </Stack>
    </StepContainer>
  );

  const renderStep7 = () => (
    <StepContainer title="Do you have high blood pressure?">
      {[
        {label: 'Yes', value: true},
        {label: 'No', value: false},
      ].map((option, index) => (
        <OptionButton
          key={index}
          optionSelectSingleValue={userData.isHighBP} // Pass the current selected value
          value={option.value} // Pass value to compare with userData
          option={option.label}
          onClick={() => handleOptionSelect('isHighBP', option.value)}
        />
      ))}
    </StepContainer>
  );

  const renderStep8 = () => (
    <StepContainer title="Are you taking high blood pressure medication?">
      {[
        {label: 'Yes', value: true},
        {label: 'No', value: false},
      ].map((option, index) => (
        <OptionButton
          key={index}
          optionSelectSingleValue={userData.bpMeds} // Pass the current selected value
          value={option.value} // Pass value to compare with userData
          option={option.label}
          onClick={() => handleOptionSelect('bpMeds', option.value)}
        />
      ))}
    </StepContainer>
  );

  const renderStep9 = () => (
    <StepContainer title="Have you had a heart attack before?">
      {[
        {label: 'Yes', value: true},
        {label: 'No', value: false},
      ].map((option, index) => (
        <OptionButton
          key={index}
          optionSelectSingleValue={userData.hasHadHeartAttack} // Pass the current selected value
          value={option.value} // Pass value to compare with userData
          option={option.label}
          onClick={() => handleOptionSelect('hasHadHeartAttack', option.value)}
        />
      ))}
    </StepContainer>
  );

  const renderStep10 = () => (
    <StepContainer title="Have you had a stroke before?">
      {[
        {label: 'Yes', value: true},
        {label: 'No', value: false},
      ].map((option, index) => (
        <OptionButton
          key={index}
          option={option.label}
          onClick={() => handleOptionSelect('hasHadStroke', option.value)}
          optionSelectSingleValue={userData.hasHadStroke} // Pass the current selected value
          value={option.value} // Pass value to compare with userData
        />
      ))}
    </StepContainer>
  );

  const renderStep11 = () => (
    <StepContainer
      isWellnessScreen="true"
      title="What are your wellness goals? "
      childrenSx={{
        gap: 1,
      }} //create gap between option
      sx={{
        // mt: {
        //     xs: "16px",
        //     sm: 2,
        //     md: 2
        // },
        gap: {
          xs: '12px', //gap between title & option
          sm: 1,
          md: 1,
          lg: 1,
        },
        maxWidth: {
          xs: '94%',
        },
      }}
      btnTitle="Next"
      skipBtnTitle="No, skip"
      onClickNext={() => handleNextStep('wellnessGoal')}
      onClickSkip={() => handleSkip('wellnessGoal')}
      btnsx={{
        mt: {xs: '10px'},
        gap: 0,
      }}
    >
      {[
        {label: 'More physical energy and mental clarity', value: 'more physical energy and mental clarity'},
        {label: 'Better moods and less stress', value: 'better moods and less stress'},
        {label: 'Improve my daily digestion and gut health', value: 'improve my daily digestion and gut health'},
        {
          label: 'Build a stronger immune system for less sick days',
          value: 'build a stronger immune system for less sick days',
        },
        {
          label: 'Feel calmer before bed and get more restful sleep',
          value: 'feel calmer before bed and get more restful sleep',
        },
        {label: 'Give me foundational nutrition', value: 'give me foundational nutrition'},
      ].map((option, index) => (
        <OptionButton
          onClick={() => handleOptionToggle(option.value)}
          key={index}
          option={option.label}
          isSelected={userData?.wellnessGoal?.includes(option.value)}
          optionSelectSingleValue={userData?.wellnessGoal} // Pass the current selected value
          value={option.value} // Pass value to compare with userData
          optionSx={{
            padding: '2px ',
            fontSize: {
              xs: '12px',
              sm: '15px',
              md: '16px',
              lg: '16px',
            },
          }}
          optionBtnSx={{
            width: {xs: '98%', sm: '340px', lg: '380px', md: '400px'},
            boxShadow: 'rgba(0, 0, 0, 0.15) 0px 1px',
            margin: '0px 0px',
            height: {xs: '34px', sm: '45px', md: '50px', lg: '50px'},
            marginBottom: '0px',
          }}
        />
      ))}
      <Box
        sx={{
          width: {xs: '98%', sm: '340px', lg: '380px', md: '400px'},
        }}
      >
        <CommonErrorMessage text={formError?.wellnessGoal && formError.wellnessGoal}></CommonErrorMessage>
      </Box>
    </StepContainer>
  );

  const renderStep12 = () => (
    <CustomFildForDetailQuestion
      inputValue={inputValue}
      filteredOptions={filteredOptions}
      handleSuggestedOptionSelect={(field, options) =>
        handleSuggestedOptionSelect(field, options, medicalConditionsData)
      } //pass third param as list of suggested item for field
      title="Do you have any medical conditions? "
      minRows={1}
      answerArray={userData.medicalCondition}
      placeholder="Enter medical condition name"
      value={inputValue}
      onChange={e => CustomFildForDetailQuestionInputChange(e, 'medicalCondition', medicalConditionsData)} //pass second param as list of suggested item for field
      onKeyDown={e => CustomFieldForDetailQuestionKeyPress(e, 'medicalCondition')}
      isAddButtonInUI="true"
      onAddBtnClick={e => onAddBtnClick(e, 'medicalCondition')}
      onClickNext={() => handleNextStep('medicalCondition')}
      onClickSkip={() => handleSkip('medicalCondition')}
      field="medicalCondition"
      onCloseIconClickInOptionArrayList={onCloseIconClickInOptionArrayList}
      btnTitle="Next"
      skipBtnTitle="No, skip"
      isFieldError={formError?.medicalCondition && formError?.medicalCondition}
    />
  );

  const renderStep13 = () => (
    <CustomFildForDetailQuestion
      title="Do you have any allergies? "
      inputValue={inputValue}
      filteredOptions={filteredOptions}
      handleSuggestedOptionSelect={(field, options) => handleSuggestedOptionSelect(field, options, allergenData)} //pass third param as list of suggested item for field
      onChange={e => CustomFildForDetailQuestionInputChange(e, 'allergies', allergenData)} //pass second param as list of suggested item for field
      minRows={1}
      answerArray={userData.allergies}
      placeholder="Enter allergy name"
      value={inputValue}
      onKeyDown={e => CustomFieldForDetailQuestionKeyPress(e, 'allergies')}
      isAddButtonInUI="true"
      onAddBtnClick={e => onAddBtnClick(e, 'allergies')}
      field="allergies"
      onCloseIconClickInOptionArrayList={onCloseIconClickInOptionArrayList}
      onClickNext={() => handleNextStep('allergies')}
      onClickSkip={() => {
        handleSkip('allergies');
      }}
      btnTitle="Next"
      skipBtnTitle="No,skip"
      isFieldError={formError?.allergies && formError?.allergies}
    />
  );

  //    const renderStep14 = () => (
  //        <StepContainer title="What is your name? "
  //            sx={{ marginTop: "70px" }}
  //            onClickNext={() => handleNextStep("name")}
  //            onClickSkip={() => handleSkip("name")}
  //            btnTitle="Next"
  //            skipBtnTitle="Skip">
  //            <CustomTextField
  //                placeholder="Enter your name"
  //                minRows={1}
  //                value={userData.name}
  //                onChange={(e) => handleInputChange("name", e.target.value)}
  //            />
  //            {
  //                <CommonErrorMessage text={formError?.name && formError?.name} sx={{
  //                    width: {
  //                        xs: '300px',
  //                        sm: '360px',
  //                        md: '400px',
  //                    }, //keep the with same as its input width
  //                }} />
  //            }
  //        </StepContainer>
  //    );

  const renderStep14 = () => (
    //    const renderStep15 = () => (
    <StepContainer title="Are you currently taking any supplements?">
      {[
        {label: 'Yes', value: true},
        {label: 'No', value: false},
      ].map((option, index) => (
        <OptionButton
          key={index}
          optionSelectSingleValue={userData.isTakingSupplements} // Pass the current selected value
          value={option.value} // Pass value to compare with userData
          option={option.label}
          onClick={() => handleOptionSelect('isTakingSupplements', option.value)}
        />
      ))}
    </StepContainer>
  );

  const renderStep15 = () => (
    //    const renderStep16 = () => (
    <CustomFildForDetailQuestion
      extraText=" Please search and list the supplements you are currently using."
      inputValue={inputValue}
      filteredOptions={filteredOptions}
      handleSuggestedOptionSelect={(field, options) => handleSuggestedOptionSelect(field, options, drugData)} //pass third param as list of suggested item for field
      onChange={e => CustomFildForDetailQuestionInputChange(e, 'supplements', drugData)} //pass second param as list of suggested item for field
      title="Can you tell us more? "
      minRows={1}
      answerArray={userData.supplements}
      placeholder="Enter supplement name"
      value={inputValue}
      onKeyDown={e => CustomFieldForDetailQuestionKeyPress(e, 'supplements')}
      isAddButtonInUI="true"
      onAddBtnClick={e => onAddBtnClick(e, 'supplements')}
      field="supplements"
      onCloseIconClickInOptionArrayList={onCloseIconClickInOptionArrayList}
      onClickNext={() => handleNextStep('supplements')}
      onClickSkip={() => handleSkip('supplements')}
      btnTitle="Next"
      skipBtnTitle="No, skip"
      isFieldError={formError?.supplements && formError?.supplements}
    />
  );

  //    const renderStep17 = () => (
  //        <StepContainer title="What is your email? ( We’d like to send you a little something!) "
  //            // sx={{ marginTop: "60px" }}
  //            onClickNext={() => handleNextStep("email")}
  //            onClickSkip={() => { handleSkip('email') }}
  //            btnTitle="Next"
  //            skipBtnTitle="Skip">
  //            <CustomTextField
  //                placeholder="Enter email"
  //                minRows={1}
  //                value={userData.email}
  //                onChange={(e) => handleInputChange("email", e.target.value)}
  //            />
  //            {/* <Typography textAlign="start" width="100%" color="red">{emailError}</Typography> */}
  //            {
  //                <CommonErrorMessage text={formError?.email && formError?.email}
  //                    sx={{
  //                        width: {
  //                            xs: '300px',
  //                            sm: '360px',
  //                            md: '400px',
  //                        }, //keep the with same as its input width
  //                    }} />
  //            }
  //        </StepContainer>
  //    );

  const commonTypographyStylesForAtpl = {
    fontSize: {
      xs: '14px',
      md: '18px',
      sn: '18px',
      lg: '18px',
    },
    fontWeight: 400,
    lineHeight: '27px',
    padding: {
      lg: '0px 5px 0px 20px',
      sm: '0px 5px 0px 8px',
    },
  };

  const renderStep16 = () => (
    //    const renderStep18 = () => (
    <StepContainer
      onClickNext={GetMyResultBtnhandler}
      btnTitle="Get My Results!"
      // sx={{
      //     marginTop: {
      //         xs: '20px',
      //         md: '20px',
      //         sm: '16px',
      //         lg: '40px'
      //     }

      // }}
      btnsx={{
        mt: {xs: '0px'},
      }}
    >
      <Box>
        {/* 1st Terms checkbox */}
        <Box>
          <FormControlLabel
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
            }}
            control={
              <Checkbox
                name="agreeTerm1"
                checked={isTermsChecked.agreeTerm1}
                onChange={handleCheckboxChange}
                color="primary"
                sx={{
                  padding: '4px',
                  '&.MuiCheckbox-root.Mui-checked': {
                    color: '#ee5c36 !important',
                  },
                  '&.MuiCheckbox-root.MuiCheckbox-indeterminate': {
                    color: '#ee5c36 !important',
                  },
                }}
              />
            }
            label={
              <Box alignItems="center">
                <Typography sx={commonTypographyStylesForAtpl} color="#000000">
                  I understand the information provided in this assessment is not intended for the diagnosis, treatment
                  and prevention of disease, but rather to provide me general information about my health and products
                  that may be able to improve my wellbeing.
                </Typography>
              </Box>
            }
            // Optional styling
          />
        </Box>

        {/* 2nd terms checkbox */}
        <Box
          sx={{
            pt: {
              xs: '8px',
              sm: '8px',
              md: '14px',
              lg: '14px',
            },
          }}
        >
          <FormControlLabel
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
            }}
            control={
              <Checkbox
                name="agreeTerm2"
                checked={isTermsChecked.agreeTerm2}
                onChange={handleCheckboxChange}
                color="primary"
                sx={{
                  padding: '4px',
                  '&.MuiCheckbox-root.Mui-checked': {
                    color: '#ee5c36 !important',
                  },
                  '&.MuiCheckbox-root.MuiCheckbox-indeterminate': {
                    color: '#ee5c36 !important',
                  },
                }}
              />
            }
            label={
              <Box alignItems="center">
                <Typography color="#000000" sx={commonTypographyStylesForAtpl}>
                  I have read and understood the
                  <Button
                    onClick={handleTermsOfUse}
                    sx={{
                      color: '#ee5c36',
                      textDecoration: 'underline',
                      fontWeight: '600',
                      padding: '0px 6px',
                      fontSize: {
                        xs: '14px',
                        md: '18px',
                        sn: '18px',
                        lg: '18px',
                      },
                    }}
                  >
                    {' '}
                    terms of use
                  </Button>
                  <span
                    style={{
                      color: '#000000',
                      fontSize: {
                        xs: '14px',
                        md: '18px',
                        sn: '18px',
                        lg: '18px',
                      },
                    }}
                  >
                    {' '}
                    and
                  </span>
                  <Button
                    onClick={handlePrivacyPolicy}
                    sx={{
                      color: '#ee5c36',
                      textDecoration: 'underline',
                      fontWeight: '600',
                      padding: '0px 6px',
                      fontSize: {
                        xs: '14px',
                        md: '18px',
                        sn: '18px',
                        lg: '18px',
                      },
                    }}
                  >
                    {' '}
                    privacy policy
                  </Button>
                </Typography>
              </Box>
            }
          />
        </Box>
      </Box>
    </StepContainer>
  );

  return (
    <>
      {isLoading ? (
        <SimpleLoader
          loadingText="Loading..."
          textColor="#F15C30"
          // secondsToLoad={60}
          // isAlmostComplete={responseReturned}
        />
      ) : (
        <Box
          className="atpl-default-css-config" // Ensures the default ATPL CSS is applied to this element
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: {
              xs: '88vh', // Adjust height for mobile devices to account for the footer, making it responsive
              sm: '98vh',
              md: '100vh',
              lg: '100vh',
            }, // Full viewport height
            bgcolor: 'white',
            overflowX: 'hidden',
          }}
        >
          {/* Progress Bar */}
          <Box
            sx={{
              px: {xs: 2, sm: 4, md: 30},
              pt: {xs: '6px', sm: 2, md: 2},
              mb: {xs: '2px', sm: 1, md: 1, lg: 2}, //distance between stepper & title
            }}
          >
            <Stack textAlign="start">
              {/* {
                            currentStep > 2 && <ArrowBackIosNewIcon sx={{ fontSize: 19, padding: "4px 0px" }} />
                        } */}

              <ATPLBackButton onClick={onBackArrowClickHandler} />
            </Stack>
            <AtplLinearBar value={currentStep * (100 / 15)} />
          </Box>

          {/* Main Content Area */}
          <Box
            component="main"
            sx={{
              boxSizing: 'border-box',
              flex: 1, // Takes up remaining space
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              px: {xs: 1, sm: 4},
              // mb: 4 // Space before footer
              mb: {xs: '14px', sm: 3, md: 4, lg: currentStep == 10 ? 1 : 4}, // if wellness step mb is 8px
            }}
          >
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                // pt: { xs: 2, sm: 3, md: 3, lg : "2px" }
              }}
            >
              {renderStep()}
            </Box>
          </Box>

          {/* Footer */}
          <Box
            component="footer"
            sx={{
              width: '100%',
              // pb: 3,
              pb: {xs: '0px', sm: 2, md: 1, lg: 2},
              bgcolor: 'white',
            }}
          >
            <AtplFooter footerTitle="This health assessment is powered by" />
          </Box>

          {
            <Snackbar
              open={isTermsChecked.termsNotAgreedError}
              autoHideDuration={3000}
              onClose={() => {
                setIsTermChecked(prevState => ({
                  ...prevState,
                  termsNotAgreedError: false,
                }));
              }}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Alert
                variant="filled"
                severity="error"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  textAlign: 'center',
                  mb: 8,
                  fontSize: {
                    xs: 16,
                    sm: 18,
                  },
                  px: {
                    xs: 2,
                    sm: 5,
                  },
                  borderRadius: 3,
                }}
              >
                You must agree to terms and conditions to continue.
              </Alert>
            </Snackbar>
          }

          {/* Privacy & terms content */}
          {/* Confirmation dialog box when user clicks Cancel button on footer */}
          <ConfirmationDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
          {/* Modal box when user clicks terms of use link */}
          <Dialog
            open={openModalTerms}
            maxWidth="sm"
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
            PaperProps={{
              sx: {
                borderRadius: '30px',
                position: 'absolute',
                mx: {
                  xs: 2,
                  md: 'auto',
                },
              },
            }}
            sx={{
              top: theme.spacing(5),
              paddingY: theme.spacing(2),
              '& .MuiDialog-paperScrollPaper': {
                borderRadius: 5,
              },
            }}
          >
            <Snackbar
              open={isServerError}
              autoHideDuration={8000}
              onClose={() => setIsServerError(false)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
            >
              <Alert
                variant="filled"
                severity="error"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  textAlign: 'center',
                  mb: 8,
                  fontSize: {
                    xs: 16,
                    sm: 18,
                  },
                  px: {
                    xs: 2,
                    sm: 5,
                  },
                  borderRadius: 3,
                }}
              >
                An error occurred.Please try again later.
              </Alert>
            </Snackbar>
            <DialogTitle sx={{paddingY: theme.spacing(3)}}>
              <Typography component="span" variant="h6">
                TERMS OF SERVICE AGREEMENT
              </Typography>
            </DialogTitle>
            <DialogContent
              sx={{
                paddingY: theme.spacing(5),
                paddingRight: theme.spacing(3),
              }}
            >
              <TermsOfServiceContent />
            </DialogContent>
            <DialogActions sx={{paddingBottom: theme.spacing(2)}}>
              <Button variant="text" onClick={() => closeTermsModal(false)}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
          {/* Modal box when user clicks privacy policy link */}
          <Dialog
            open={openModalPrivacy}
            maxWidth="sm"
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
            PaperProps={{
              sx: {
                borderRadius: '30px',
                position: 'absolute',
                mx: {
                  xs: 2,
                  md: 'auto',
                },
              },
            }}
            sx={{
              top: theme.spacing(5),
              paddingY: theme.spacing(2),
              '& .MuiDialog-paperScrollPaper': {
                borderRadius: 5,
              },
            }}
          >
            <DialogTitle sx={{paddingY: theme.spacing(3)}}>
              <Typography component="span" variant="h6">
                PRIVACY POLICY
              </Typography>
            </DialogTitle>
            <DialogContent
              sx={{
                paddingY: theme.spacing(5),
                paddingRight: theme.spacing(3),
              }}
            >
              <PrivacyContent isPage={false} />
            </DialogContent>
            <DialogActions sx={{paddingBottom: theme.spacing(2)}}>
              <Button variant="text" onClick={() => closePrivacyPolicyModal(false)}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      )}
    </>
  );
};

// Updated OptionButton component to ensure center alignment
export const OptionButton = ({option, onClick, optionSx, optionBtnSx, isSelected, optionSelectSingleValue, value}) => {
  const preSelectStyleForSlectedSinglevalue = {
    borderRadius: '10px',
    backgroundColor: 'var(--atplGreyColor)',
  };
  const isSingleOptionSelected = optionSelectSingleValue === value;

  const theme = useTheme();
  const isLaptopUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Button
      sx={{
        width: {
          xs: '280px',
          sm: '300px',
          md: '400px',
          lg: '450px',
        },
        height: {
          xs: '54px',
          md: '60px',
          sm: '60px',
          lg: '60px',
        },
        backgroundColor: isSelected ? 'var(--atplGreyColor)' : 'rgba(26, 26, 26, 0.08)',
        marginBottom: '10px',
        borderRadius: isSelected ? '10px' : '0px',
        transition: 'all 0.3s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: isSelected ? 'white' : '#000', //this will set child black & on hover white
        mx: 'auto', // Added to ensure center alignment
        borderRadius: '10px',

        ...(!isSelected && isSingleOptionSelected ? preSelectStyleForSlectedSinglevalue : {}),
        '&:hover': {
          transform: 'translateY(-2px)',
          // boxShadow: '0 2px 8px rgba(238, 92, 54, 0.15)',
          backgroundColor: isLaptopUp ? 'var(--atplGreyColor)' : 'rgba(26, 26, 26, 0.08)',
          color: isLaptopUp ? 'white' : '#000',
          borderRadius: '10px',
        },
        ...optionBtnSx,
      }}
      onClick={onClick}
    >
      <Typography
        sx={{
          fontSize: {
            xs: '14px',
            sm: '15px',
            md: '16px',
          },

          fontWeight: isSelected ? '600' : '500',
          lineHeight: '22.5px',
          textAlign: 'center',
          width: '100%',
          ...optionSx,
        }}
      >
        {option}
      </Typography>
    </Button>
  );
};

// Update StepContainer component for better spacing
export const StepContainer = ({
  title,
  children,
  subTitle = '',
  btnTitle,
  onClickNext,
  onClickSkip,
  skipBtnTitle,
  sx,
  btnsx,
  childrenSx,
  isWellnessScreen,
}) => {
  return (
    <Stack
      sx={{
        width: '100%',
        maxWidth: {
          xs: '300px',
          sm: '390px',
          md: '400px',
          lg: '800px',
        },
        // marginTop: "60px",
        mx: 'auto',
        alignItems: 'center',
        justifyContent: 'flex-start',
        // justifyContent: 'cenetr',
        gap: 3,
        ...sx,
      }}
    >
      <Typography
        sx={{
          fontSize: {xs: '20px', sm: '23px', md: '26px'},
          fontWeight: '700',
          lineHeight: {xs: '24px', sm: '27px', md: '32px'},
          textAlign: 'center',
          px: {xs: 1, sm: 4},
          width: '100%',
          paddingTop: {
            xs: '10px',
            sm: 1,
          },
          marginBottom: '10px',
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          ...childrenSx,
        }}
      >
        {children}
      </Box>

      {(btnTitle || skipBtnTitle) && (
        <Stack
          sx={{
            maxWidth: '342px',
            width: '100%',
            alignItems: 'center',
            mt: {xs: 1, sm: 3},
            ...btnsx,
          }}
        >
          {btnTitle && (
            <AtplPrimaryBtnNew
              sx={{
                maxWidth: '342px',
                width: '100%',
                marginTop: {xs: '4px', sm: '30px', md: '20px', lg: isWellnessScreen == 'true' ? '10px' : '20px'},
              }}
              text={btnTitle}
              onClick={onClickNext}
            />
          )}
          {skipBtnTitle && (
            <Button
              onClick={onClickSkip}
              sx={{
                mt: {xs: '4px', sm: '10px', md: '12px', lg: isWellnessScreen === 'true' ? '8px' : '16px'},
                marginBottom: isWellnessScreen === 'true' && {lg: '14px', ms: '14px', sm: '14px', xs: '2px'},
                color: '#A1A0A0',
                fontSize: {xs: '15px', sm: '17px'},
                fontWeight: '600',
                '&:hover': {
                  color: '#ee5c36',
                  backgroundColor: 'transparent',
                },
              }}
            >
              {skipBtnTitle}
            </Button>
          )}
        </Stack>
      )}
    </Stack>
  );
};

// Enhanced CustomTextField component
const CustomTextField = ({
  placeholder,
  minRows = 1,
  value,
  onChange,
  onKeyDown,
  sx = {},
  onAddBtnClick,
  isAddButtonInUI = 'false',
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        // my: 2
        // my: { xs: "10px", sm: "10px", md: "10px", lg: "10px" },
        my: '10px',
      }}
    >
      <TextField
        fullWidth
        minRows={minRows}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        sx={{
          width: {
            xs: '300px',
            sm: '360px',
            md: '400px',
          },
          // mt: 4,
          // mt: { xs: 1, sm: 2, md: 4, lg: 4 },
          mt: {xs: 1, md: '10px', lg: '14px'},
          backgroundColor: '#F5F5F5;',
          borderRadius: '12px',
          '& .MuiOutlinedInput-root': {
            // boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
            transition: 'all 0.2s ease-in-out',
            '& fieldset': {
              border: 'none', // remove default border from txtfield
            },

            '&.Mui-focused': {
              '& fieldset': {
                border: '1px solid var(--atplGreyColor)',
                borderRadius: '10px',
              },
            },
          },
          '& .MuiInputBase-input': {
            fontSize: {
              xs: '16px',
              sm: '19px',
            },
            lineHeight: '28.5px',
            fontWeight: 500,
            padding: '16px 14px',
          },
          '& ::placeholder': {
            color: 'rgba(0, 0, 0, 0.20)',
            opacity: 1,
            fontSize: {
              xs: '14px',
              sm: '19px',
            },
            fontWeight: 500,
          },
          ...sx,
        }}
        placeholder={placeholder}
        InputProps={{
          endAdornment: isAddButtonInUI === 'true' && (
            <InputAdornment
              position="end"
              sx={{
                marginLeft: 0,
                paddingLeft: 0,
              }}
            >
              <Box
                onClick={onAddBtnClick}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '4px 2px',
                  cursor: 'pointer',
                }}
              >
                <Typography
                  sx={{
                    fontSize: {xs: '14px', sm: '16px', md: '18px', lg: '18px'},
                    fontWeight: 500,
                    color: 'var(--atplGreyColor)',
                    color: '#000',
                    fontSize: '14px',
                  }}
                >
                  Add +
                </Typography>
              </Box>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

const CustomFildForDetailQuestion = ({
  filteredOptions,
  inputValue,
  handleSuggestedOptionSelect,
  title,
  placeholder,
  minRowsCount = 1,
  answerArray,
  onChange,
  value,
  onKeyDown,
  extraText,
  supplemtNameCss,
  btnTitle,
  onClickNext,
  onClickSkip,
  skipBtnTitle,
  onAddBtnClick,
  isAddButtonInUI,
  onCloseIconClickInOptionArrayList,
  field,
  isFieldError,
}) => (
  <StepContainer
    // sx={{
    //     marginTop: { xs: '40px', sm: '34px', md: '38px', lg: '50px' },
    // }}
    title={title}
    subTitle={extraText}
    btnTitle={btnTitle}
    onClickNext={onClickNext}
    onClickSkip={onClickSkip}
    skipBtnTitle={skipBtnTitle}
  >
    {extraText && (
      <Typography
        color="#000"
        sx={{
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '18px',
          textAlign: 'center',
        }}
      >
        {extraText}
      </Typography>
    )}
    <CustomTextField
      isAddButtonInUI={isAddButtonInUI}
      minRows={minRowsCount}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      onAddBtnClick={onAddBtnClick}
    />
    {isFieldError && (
      <CommonErrorMessage
        text={isFieldError}
        sx={{
          width: {
            xs: '300px',
            sm: '360px',
            md: '400px',
          },
        }}
      />
    )}
    {/* suggested list */}
    {filteredOptions?.length > 0 && inputValue && (
      <Stack
        sx={{
          maxHeight: '200px',
          overflowY: 'scroll',
          border: '1px solid #ccc',
          borderRadius: '8px',
          padding: '8px',
          backgroundColor: '#fff',
        }}
      >
        {filteredOptions.map((option, index) => (
          <Box
            key={index}
            sx={{
              padding: '8px 4px',
              cursor: 'pointer',
              width: {
                xs: '300px',
                sm: '360px',
                md: '400px',
              },
              boxSizing: 'border-box',
              '&:hover': {backgroundColor: 'var(--atplGreyColor)', color: 'white'},
            }}
            onClick={() => handleSuggestedOptionSelect(field, option)}
          >
            <Typography fontWeight="500" fontSize="14px" lineHeight="18px">
              {option}
            </Typography>
          </Box>
        ))}
      </Stack>
    )}
    {/* lsit of user added medicalCondition, allergy, supplemets  */}
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        alignItems: 'start',
        padding: '0px 8px',
        boxSizing: 'border-box',
        flexWrap: 'wrap',
        marginTop: '20px',
        //keep this width as equal to textfiled width so option will show exactly belw of input
        width: {
          xs: '300px',
          sm: '360px',
          md: '400px',
        },
      }}
    >
      {answerArray?.length > 0 &&
        answerArray.map((option, index) => (
          <Box
            key={index}
            sx={{
              borderRadius: '30px',
              backgroundColor: '#EBEBEB',
              borderRadius: '28px',
              display: 'flex',
              justifyContent: 'space-between',
              minWidth: '90px',
              marginRight: '10px',
              marginBottom: '10px',
              minHeight: '36px',
              boxSizing: 'border-box',
              alignItems: 'center',
              // justifyContent : "center",
              // padding: "6px 10px",
              // padding: "12px 12px",
              padding: '14px 20px',
              minWidth: '105px',
              alignItems: 'center',
            }}
          >
            <Typography sx={{wordBreak: 'break-word', fontWeight: '500', fontSize: '12px', lineHeight: '18px'}}>
              {option}
            </Typography>
            <Box
              // On clicking the close icon next to an item in the list, it will remove that item from the array of the specified field.
              onClick={() => onCloseIconClickInOptionArrayList(option, field)}
              sx={{
                padding: '0px 4px 0px 10px',
                cursor: 'pointer',
              }}
            >
              <CloseIcon fontSize="10px" />
            </Box>
          </Box>
        ))}
    </Stack>
  </StepContainer>
);
